import {
  TrackingPromotionCreative,
  originClick,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions, useTrackOriginClick} from '@aboutyou/tracking';
import {
  Card as BaseCard,
  COLORS,
  CardContentContainer,
  FONT_SIZES,
  FONT_WEIGHTS,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CardType} from '../utils/normalizeSpotlightCards';

export const Card: React.FC<CardType & {isCloseToViewport: boolean}> = ({
  isCloseToViewport,
  image,
  topline,
  headline,
  href,
  promotionTracker,
}) => {
  const trackOriginClick = useTrackOriginClick();

  return (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.Teaser,
        heroElement: {...promotionTracker},
      }}
      streamPosition={0}
      triggerOnce
      Comp="li"
    >
      <BaseCard
        data-testid="streetwearCardSlider"
        isCloseToViewport={isCloseToViewport}
        image={image}
        href={href}
        onClick={trackOriginClick(promotionTracker.locationId as originClick)}
      >
        <CardContentContainer>
          <TopLine>{topline}</TopLine>
          <Headline>{headline}</Headline>
        </CardContentContainer>
      </BaseCard>
    </TrackPromotions>
  );
};

const Headline = styled(Text)`
  line-height: ${FONT_SIZES.px28};
  color: ${COLORS.White};
  font-size: ${FONT_SIZES.px48};
  line-height: ${FONT_SIZES.px54};
`;

const TopLine = styled(Text)`
  margin-bottom: 8px;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  color: ${COLORS.White};
  text-transform: uppercase;
  font-size: ${FONT_SIZES.px14};
  line-height: ${FONT_SIZES.px20};
`;
